module.exports = __webpack_public_path__ + "static/media/English_Indian_Aditi BG-39.502379e6.png";